module.exports = __webpack_public_path__ + "static/cb_logo-31eb9f3fb36aed2c94a90d9381a623f1.png";